export const ADMIN_PANEL_SHELL_STYLE = Object.freeze({
  position: "fixed",
  inset: 0,
  background: "#080808",
  zIndex: 12000,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  overflow: "hidden",
});

export const ADMIN_PREVIEW_SHELL_STYLE = Object.freeze({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  minHeight: 0,
  overflow: "hidden",
});

export const ADMIN_PREVIEW_SCROLL_STYLE = Object.freeze({
  flex: "1 1 auto",
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  WebkitOverflowScrolling: "touch",
  overscrollBehavior: "contain",
  touchAction: "pan-y",
});

export const ADMIN_PREVIEW_ACTIONS_STYLE = Object.freeze({
  flexShrink: 0,
  background: "#080808",
  borderTop: "1px solid #1e1e1e",
  padding: "14px 20px",
  display: "flex",
  gap: 10,
});
